import { recordTooltipViewed } from '@streem/analytics';
import { google } from 'streem-sdk-protobuf';

export function timestampToDate(timestamp?: google.protobuf.ITimestamp): Date | null {
    if (!timestamp?.seconds) return null;
    const millis = timestamp.seconds.toNumber() * 1000;
    return new Date(millis);
}

export const CONFIRM_SEND_NOTE_BUTTON_ID = 'confirm-send-note-button';
export const SEND_NOTE_BUTTON_ID = 'send-note-button';
export const CANCEL_SEND_NOTE_BUTTON_ID = 'cancel-send-note-button';
export const NOTE_SEND_TOOLTIP_ID = 'note-send-tooltip';

export function recordTooltipHover(): void {
    recordTooltipViewed(NOTE_SEND_TOOLTIP_ID);
}
